<template>
  <div class="ncbc_home">

    <div class="container" style="background:rgba(0,0,0,.5);">
      <div class="row">
        <div class="col-12 col-md-6" style="opacity:0.85;">
          <div style="padding:15px 0;">
            <span style="color:#fff">Current Calendar</span>
            <events :days=3 ></events>
            <div class="row">
              <div class="col-6" style="text-align:left">
                <span style="color:#fff;text-decoration:italic">Powered by:</span><a href="https://www.badmintonunited.org" target="_blank"><img src="../assets/images/bu_logo.png" style="width:100px" /></a>
              </div>
              <div class="col-6" style="text-align:right">
                <router-link class="top_menu_a" to="/booking/events" style="font-size:19px; font-weight:400">See full calendar</router-link>
              </div>
            </div>
            <div style="clear:both"></div>
          </div>

          <div style="padding-top:35px" class="d-block d-sm-block d-md-none d-lg-none"><hr></div>
        </div>

        <div class="col-12 col-md-6" style="opacity:0.80; text-align:left; color:#fff; overflow-y:auto; max-height:550px;">
          <div class="p-2">
            <p style="font-weight:bold">Latest News</p>
            <p v-if="loading_news">Loading latest updates...</p>
            <p v-else-if="bu_news.trim() === ''">No news posted yet.</p>
            <div v-else class="news_blob" v-html="bu_news"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import datetime_mixin from '../mixins/datetime.js'
import events from './booking/events.vue';

export default {
  mixins: [datetime_mixin],
  components: {
    events
  },
  data() {
    return {
      bu_news: '',
      loading_news: false,
    }
  },
  mounted() {
    this.getCenterSettings();
  },
  methods:{
    getCenterSettings () {
      this.loading_news = true
      this.$http.get('/api/center_settings?center_id=1').then((resp) => {
        this.bu_news = resp.data.bu_news || ''
      }).catch(() => {
        this.bu_news = ''
      }).finally(() => {
        this.loading_news = false
      })
    },
    covidMsg () {
      this.$bvModal.msgBoxOk("With the new stay at home order, once our region's ICU capacity falls below 15%, all non essential activities including NCBC will close. Our gym status is updated daily to refect our opening status.",{
          centered: true,
      })
    },
  }
}
</script>


<style scoped lang="scss">
.top_menu_a {
  color:#fff;
  font-weight: 400;
  font-size: 18px;
}

a {
  color: #fabe57;
}

.news_blob {
  line-height: 1.7;
}

.news_blob :deep(a) {
  color: #fabe57;
}

.news_blob :deep(p),
.news_blob :deep(ul),
.news_blob :deep(ol) {
  margin-bottom: 1rem;
}
</style>
